import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import OitProgressChart from './OitProgressChart';
import dashboardActionCreators from '../../store/dashboard/action-creators';
import LoadingOverlay from '../../../shared/components/LoadingOverlay';
import DashboardReports from "./DashboardReports";
import {
  reportsDueAcknowledgement,
  reportsDueApprove,
  reportsDueSubmit,
  reportsWaitingApprove,
  reportsWaitingReview, reportsWaitingSubmit
} from "../../store/reports/selectors";
import riskAlertsSelectors from "../../store/risk-alerts/selectors";
import riskAlertsActionCreators from "../../store/risk-alerts/action-creators";
import reportsActionCreators from "../../store/reports/action-creators";
import Modal from "../../../shared/ui/Modal";
import departmentSettingsSelectors from "../../store/department-settings/selectors";
import DashboardOitReport from "./DashboardOitReport";
import TimeAnalytics from "../analytics/TimeAnalytics";
import DashboardAnalyticsReport from "./DashboardAnalyticsReport";
import DashboardStatisticsReport from "./DashboardStatisticsReport";
import DashboardFtoReport from "./DashboardFtoReport";
import DashboardFtoStatisticsReport from "./DashboardFtoStatisticsReport";
import DashboardLogReport from "./DashboardLogReport";
import DashboardTaskTraining from "./DashboardTaskTraining";
import ftosActionCreators from "../../store/ftos/action-creators";
import CommonCreateReport from "../common/CommonCreateReport";
import ReportViewSplit from "../reports/ReportViewSplit";
import ModalSplit from "../../../shared/ui/ModalSplit";

class CstaffDashboard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isTaskResponseAckLoading: false,
      oitComment: '',
      lateOitComment: '',
      showCreateReportDialog: false
    };
  }
  componentDidMount() {
    this.props.fetchActiveOits();
    this.props.fetchFtos();
    this.props.fetchReports();
    this.props.fetchRiskAlerts();
  }

  openReport(report) {
    this.props.setIsViewingReport(report);
  }

  get isLoading() {
    return (
      this.props.isLoadingReports.includes('fetchReports') ||
      this.props.isLoadingOits.includes('fetchOits') ||
      this.props.isLoadingRiskAlerts.includes('fetchRiskAlerts')
    );
  }

  render() {
    return (
      <Fragment>
        <div className="app-content-header">
          <h4 className="title">Dashboard</h4>
          <p className="sub-title text-muted">
            <button onClick={() => this.setState({showCreateReportDialog: true})} className="button primary small">Create report</button> Command Staff
          </p>
        </div>

        <div className="app-content dashboard">
          <LoadingOverlay isLoading={this.isLoading}>

            <div className="dashboard-reports-deck">
              <DashboardOitReport
                title="View Total Training Hours by Phase & Total Program"
                multiple={true}
              >
                {(oitGuids) => <TimeAnalytics oitGuids={oitGuids}/>}
              </DashboardOitReport>
              <DashboardOitReport
                title="View Remedial Training Minutes by Observation & Phase"
                multiple={true}
              >
                {(oitGuids) => <DashboardAnalyticsReport oitGuids={oitGuids} type="time-spend"/>}
              </DashboardOitReport>
              <DashboardOitReport
                title={`View ${this.props.oitShortLabel} Performance Statistics Against Average`}
                multiple={true}
              >
                {(oitGuids) => <DashboardStatisticsReport oitGuid={oitGuids}/>}
              </DashboardOitReport>
            </div>
            <div className="dashboard-reports-deck">
              <DashboardOitReport
                title={`View ${this.props.oitShortLabel} GRADING ANALYTICS`}
                multiple={true}
              >
                {(oitGuids) => <DashboardAnalyticsReport oitGuids={oitGuids} type="rating" compact={false}/>}
              </DashboardOitReport>
              <DashboardFtoReport
                title={`View ${this.props.ftoShortLabel} Grading Statistics Against Department Average`}
                multiple={true}
              >
                {(ftoGuids) => <DashboardFtoStatisticsReport ftoGuids={ftoGuids}/>}
              </DashboardFtoReport>
              <DashboardOitReport
                title="VIEW FIELD OCCURRENCE LOG "
                multiple={true}
              >
                {(oitGuids) => <DashboardLogReport oitGuids={oitGuids}/>}
              </DashboardOitReport>
              <DashboardOitReport
                title="View Training Task Progress"
              >
                {(oitGuid) => <DashboardTaskTraining oitGuid={oitGuid}/>}
              </DashboardOitReport>
            </div>
            <div className="dashboard-reports-deck">

              <DashboardReports
                showOitName
                nextReportActive
                icon="list-alt"
                viewReportIcon="check"
                title="Pending My Approval"
                addReportLabel="Approve"
                nextReportLabel="Next report for approval"
                reports={[...(this.props.reportsDueApprove || []), ...(this.props.reportsWaitingApprove || [])]}
                noReportsMessage="No reports pending my approval"
                onViewReport={report => this.openReport(report)}
              />

              <DashboardReports
                showOitName
                nextReportActive
                icon="list-alt"
                viewReportIcon="edit"
                title="FORMS TO COMPLETE"
                addReportLabel="Complete new form"
                nextReportLabel="Next report for submission"
                reports={[...(this.props.reportsDueSubmit || []), ...(this.props.reportsWaitingSubmit || [])]}
                noReportsMessage="No reports pending submission"
                onViewReport={report => this.addReport(report)}
              />
            </div>
            <OitProgressChart/>
          </LoadingOverlay>
          <ModalSplit
            isOpen={!!this.props.viewingReport}
            onClose={() => this.props.setIsViewingReport(null)}
            title={this.props.viewingReport && this.props.viewingReport.formName}
          >
            <ReportViewSplit report={this.props.viewingReport}/>
          </ModalSplit>
          <Modal
            isOpen={this.state.showCreateReportDialog}
            onClose={() => this.setState({
              showCreateReportDialog: false
            })}
            title={"Create Report"}
            size={'small'}
          >
            {this.state.showCreateReportDialog && (
              <CommonCreateReport onFinish={() => this.setState({showCreateReportDialog: false})} />
            )}
          </Modal>
        </div>
      </Fragment>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    isLoading: state.dashboard.isLoading,
    isLoadingReports: state.reports.isLoading,
    isLoadingOits: state.oits.isLoading,
    isLoadingRiskAlerts: state.riskAlerts.isLoading,
    viewingReport: state.reports.viewingReport,
    reportsDueSubmit: reportsDueSubmit(state),
    reportsDueAcknowledgement: reportsDueAcknowledgement(state),
    reportsWaitingApprove: reportsWaitingApprove(state),
    reportsDueApprove: reportsDueApprove(state),
    reportsWaitingReview: reportsWaitingReview(state),
    reportsWaitingSubmit: reportsWaitingSubmit(state),
    riskAlertsReports: riskAlertsSelectors.riskAlertsReports(state),
    oitShortLabel: departmentSettingsSelectors.oitShortLabel(state),
    ftoShortLabel: departmentSettingsSelectors.ftoShortLabel(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchReports: (scope) => {
      return dispatch(reportsActionCreators.fetchReports(scope));
    },
    fetchActiveOits: () => {
      return dispatch(dashboardActionCreators.fetchActiveOits());
    },
    fetchRiskAlerts: () => {
      return dispatch(riskAlertsActionCreators.fetchRiskAlerts());
    },
    setIsViewingReport: (report) => {
      return dispatch(reportsActionCreators.setIsViewingReport(report));
    },
    fetchFtos: () => {
      return dispatch(ftosActionCreators.fetchFtos());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CstaffDashboard);
